/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback } from 'react';
import { Marker, Tooltip, useMap } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import 'leaflet/dist/leaflet.css';
/**
 * Создает объект для запроса на основе данных формы, границ карты и фильтра.
 *
 * @param {Object} formData - Объект с данными формы.
 * @param {Object} mapBounds - Объект с координатами границ карты (_southWest и _northEast).
 * @param {string} [filterInput] - Значение текстового фильтра (например, для поиска по имени).
 * @returns {Object} - Объект с параметрами запроса.
 */
function createQueryObject(formData = {}, mapBounds = {}, filterInput = '') {
  const query = { isBounds: false };

  // Добавляем параметры из formData (включая даты без преобразования)
  Object.entries(formData).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query[key] = value;
    }
  });

  // Добавляем координаты карты
  if (mapBounds?._southWest && mapBounds?._northEast) {
    query.visibleMinLat = mapBounds._southWest.lat;
    query.visibleMaxLat = mapBounds._northEast.lat;
    query.visibleMinLon = mapBounds._southWest.lng;
    query.visibleMaxLon = mapBounds._northEast.lng;
  }

  // Добавляем текстовый фильтр, если он есть
  if (filterInput?.trim()) {
    query.like = filterInput.trim();
  }

  return query;
}

// Компонент для рендеринга маркеров
const Markers = ({ getIcon, filterInput, formData, openBrigade, type, mapSearchActive, emitStartFunction }) => {
  const map = useMap();
  const dispatch = useDispatch();
  // Состояние для хранения видимых маркеров
  const visibleMarkers = useSelector((state) => state?.mapMarkers);

  // Колбек-функция для обновления видимых маркеров
  const updateVisibleMarkers = useCallback(() => {
    const bounds = map.getBounds();
    // Проверка введён ли id длинной 6 или не введён
    const isIdValid = formData?.id?.length === 6 || !formData?.id;
    const isValidType = formData?.deviceId?.length === 6 || !formData?.deviceId;

    if (isIdValid && isValidType) {
      const payload = createQueryObject(formData, bounds, filterInput);
      // Отправляем событие сокета на сервер для получения маркеров
      dispatch(emitStartFunction(payload));
    }
  }, [map, formData, mapSearchActive]);

  // Обновление видимых маркеров
  useEffect(() => {
    updateVisibleMarkers();
    map.on('moveend', updateVisibleMarkers);
    return () => {
      map.off('moveend', updateVisibleMarkers);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateVisibleMarkers]);

  // Рендеринг видимых маркеров
  return (
    <>
      {visibleMarkers?.map((marker, index) => {
        return (
          <Marker
            key={index}
            position={marker.position}
            icon={getIcon(marker.colorForMarker)}
            eventHandlers={{
              click: () => {
                if (type === 'brigades') openBrigade(Number(marker?.id));
              },
            }}
          >
            <Tooltip>{marker.popupContent}</Tooltip>
          </Marker>
        );
      })}
    </>
  );
};

export default Markers;
